<template>
    <!-- Top-aligned so the leading icon always pairs with the FIRST content
         line: the 20px icon column matches the text line-height (leading-5),
         so single-line rows centre naturally and multi-line/card rows keep
         the icon at the top left, per the design. -->
    <div class="relative flex w-full items-start gap-2 py-1">
        <!-- Leading column: actor avatar, source logo, or status dot (20px;
             min-width so the co-authored avatar PAIR may widen it, pushing
             content right per the design) -->
        <div
            class="relative z-10 flex h-5 min-w-5 shrink-0 items-center justify-center"
        >
            <slot name="leading" />
        </div>

        <!-- Content -->
        <div
            class="flex min-w-0 flex-1 flex-wrap items-center gap-x-1 gap-y-0.5 text-sm leading-5 text-secondary-foreground"
        >
            <slot />
        </div>

        <!-- Trailing timestamp, optically centred on the first content line -->
        <div
            class="shrink-0 whitespace-nowrap pt-0.5 text-xs leading-4 text-muted-foreground"
        >
            <slot name="time" />
        </div>
    </div>
</template>
